var map = {
	"./anotacoes": [
		189,
		1
	],
	"./anotacoes.js": [
		189,
		1
	],
	"./avisos": [
		178,
		2
	],
	"./avisos.js": [
		178,
		2
	],
	"./bibliotecaItem": [
		190,
		3
	],
	"./bibliotecaItem.js": [
		190,
		3
	],
	"./bibliotecaLista": [
		191,
		4
	],
	"./bibliotecaLista.js": [
		191,
		4
	],
	"./bibliotecas": [
		192,
		5
	],
	"./bibliotecas.js": [
		192,
		5
	],
	"./dashboard": [
		193,
		6
	],
	"./dashboard.js": [
		193,
		6
	],
	"./exercicios": [
		179,
		7
	],
	"./exercicios.js": [
		179,
		7
	],
	"./main": [
		85
	],
	"./main.js": [
		85
	],
	"./meuPerfil": [
		182,
		8
	],
	"./meuPerfil.js": [
		182,
		8
	],
	"./meusCursos": [
		180,
		9
	],
	"./meusCursos.js": [
		180,
		9
	],
	"./notas": [
		181,
		10
	],
	"./notas.js": [
		181,
		10
	],
	"./provas": [
		194,
		11
	],
	"./provas.js": [
		194,
		11
	],
	"./salaDeAula": [
		183,
		12
	],
	"./salaDeAula.js": [
		183,
		12
	],
	"./selecioneCurso": [
		195,
		13
	],
	"./selecioneCurso.js": [
		195,
		13
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 157;
module.exports = webpackAsyncContext;